// modules/records/hooks/useRecordActions.ts

import { evaluateCondition } from "shared/services/conditionEvaluatorForActions";
import { RecordActionConditionContext } from "modules/record/record-producer/types/record-producer-actions";
import useFormActions from "modules/record/shared/hooks/useFormActions";
import { useQuery } from "@tanstack/react-query";
import { RecordManagement } from "app/class/record-management";
import { useSession } from "app/hooks/useSession";

const ADD_TO_PACKAGE_ACTION = "ACT5173001";
const REMOVE_FROM_PACKAGE_ACTION = "ACT5173002";

const useRecordProducerActions = (tableName: string, context: RecordActionConditionContext) => {
    const { actions, isLoading } = useFormActions(tableName);
    const { data: session } = useSession();
    const versionedTable = useQuery({
        queryKey: ["package-action", "versioned-table", tableName],
        queryFn: () => new RecordManagement("version_controlled_tables").where("table_name", tableName).where("active", true).first(),
        enabled: !!session?.currentPlatformPackageId && !context.isNewRecord,
    });
    const associatedPackageId = String(context.form.platform_package_id || "");
    const associatedPackage = useQuery({
        queryKey: ["package-action", "associated-package", associatedPackageId],
        queryFn: () => new RecordManagement("platform_packages").get(associatedPackageId),
        enabled: tableName === "version_records" && !!associatedPackageId,
    });


    return {
        actions: actions
            .filter(action => action.is_form_action === true && action.is_related_action === false)
            .filter(action => {
                if (action.number_ref === ADD_TO_PACKAGE_ACTION) return !!session?.currentPlatformPackageId && !!versionedTable.data && !context.isNewRecord;
                if (action.number_ref === REMOVE_FROM_PACKAGE_ACTION) return tableName === "version_records" && !!associatedPackageId && associatedPackage.data?.status !== "committed" && !!associatedPackage.data;
                return true;
            })
            .filter(action => evaluateCondition(action.conditions, context))
            .sort((a, b) => a.order - b.order),
        isLoading
    }
}

export default useRecordProducerActions;
